(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var HOSTS = ['findapro.resideo.com'];
  var MAX_LEN = 100;

  var SOURCE = window.location.hostname;

  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function write(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function remove(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function clean(v) { return String(v).trim().replace(/[<>"']/g, '').slice(0, MAX_LEN); }

  function normalizeHost(s) {
    return String(s).trim().toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/[\/?#].*$/, '');
  }

  try {
    var el = document.getElementById('marketing-params');
    if (el) {
      var cfg = JSON.parse(el.textContent);

      if (Array.isArray(cfg.utmKeys)) {
        var k = cfg.utmKeys
          .filter(function (s) { return typeof s === 'string' && s.trim(); })
          .map(function (s) { return s.trim(); });
        if (k.length) KEYS = k;
      }

      if (typeof cfg.source === 'string' && cfg.source.trim()) {
        SOURCE = cfg.source.trim().slice(0, MAX_LEN);
      }

      if (Array.isArray(cfg.hosts)) {
        var h = cfg.hosts
          .filter(function (s) { return typeof s === 'string' && s.trim(); })
          .map(normalizeHost)
          .filter(function (s) { return s; });
        if (h.length) HOSTS = h;
      }
    }
  } catch (e) {}

  try {
    var params = new URLSearchParams(window.location.search);
    var hasNew = KEYS.some(function (key) { return params.get(key); });

    if (hasNew) {
      KEYS.forEach(function (key) { remove(key); });
      KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) write(key, clean(value));
      });
    }
  } catch (e) {}

  function decorate(e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;

    try {
      var url = new URL(link.href, window.location.origin);
      if (HOSTS.indexOf(url.hostname) === -1) return;

      KEYS.forEach(function (key) {
        var v = read(key);
        if (v) {
          url.searchParams.set(key, v);
        } 
      });

      url.searchParams.set('source', SOURCE);
      link.href = url.toString();
    } catch (err) {}
  }

  ['mousedown', 'auxclick', 'click'].forEach(function (evt) {
    document.addEventListener(evt, decorate, true);
  });
})();